import React, { useEffect, useState } from "react";
import {
  Card, CardBody, Row, Col, Input, Button
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";

const InventoryAdd = () => {

  const dispatch = useDispatch();
  const user = useSelector(s => s.customer.customer);
  const loading = useSelector(s => s.loading.loading);

  /* ================= STATES ================= */
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);

  const [product, setProduct] = useState(null);
  const [variant, setVariant] = useState(null);

  const [quantity, setQuantity] = useState("");
  const [note, setNote] = useState("");

  /* ================= LOAD PRODUCTS ================= */
  const loadProducts = async () => {
    dispatch(loadingTrue());
    try {
      const res = await Handler({
        method: "get",
        url: `/products/search.php?outlet_id=${user?.outlet_id}`
      });

      if (res?.success) {
        setProducts(
          (res.data || []).map(p => ({
            value: p.product_id,
            label: p.name,
            variants: p.variants || []
          }))
        );
      }
    } catch {
      toast.error("Failed to load products");
    }
    dispatch(loadingFalse());
  };

  useEffect(() => {
    loadProducts();
  }, []);

  /* ================= PRODUCT CHANGE ================= */
  const onProductChange = (p) => {
    setProduct(p);
    setVariant(null);
    setQuantity("");
    setNote("");

    if (p?.variants?.length) {
      setVariants(
        p.variants.map(v => ({
          value: v.variant_id,
          label: v.name
        }))
      );
    } else {
      setVariants([]);
    }
  };

  /* ================= SUBMIT ================= */
  const submit = async () => {

    if (!product) return toast.error("Select product");
    if (!quantity || Number(quantity) <= 0) return toast.error("Enter valid quantity");

    dispatch(loadingTrue());

    const payload = {
      product_id: product.value,
      outlet_id: user.outlet_id,
      quantity: Number(quantity),
      note: note
    };

    if (variant) payload.variant_id = variant.value;

    try {
      const res = await Handler({
        method: "post",
        url: "/inventory/add.php",
        data: payload
      });

      if (res?.success) {
        toast.success("Stock updated successfully");
        setQuantity("");
        setNote("");
        setVariant(null);
      } else {
        toast.error(res?.message || "Failed");
      }

    } catch {
      toast.error("Network error");
    }

    dispatch(loadingFalse());
  };

  /* ================= UI ================= */
  return (
    <>
      <Row className="mb-3">
        <Col>
          <h5 className="fw-bold">Add Stock</h5>
          <small className="text-muted">Increase inventory quantity</small>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <Row className="g-3">

            {/* PRODUCT */}
            <Col md={6}>
              <label className="small">Product *</label>
              <Select
                options={products}
                value={product}
                onChange={onProductChange}
                placeholder="Select product"
              />
            </Col>

            {/* VARIANT */}
            <Col md={6}>
              <label className="small">Variant</label>
              <Select
                options={variants}
                value={variant}
                onChange={setVariant}
                placeholder="Select variant (optional)"
                isDisabled={variants.length === 0}
                isClearable
              />
            </Col>

            {/* QUANTITY */}
            <Col md={6}>
              <label className="small">Quantity *</label>
              <Input
                type="text"
                placeholder="Enter quantity"
                value={quantity}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setQuantity(e.target.value);
                  }
                }}
              />
            </Col>

            {/* NOTE */}
            <Col md={6}>
              <label className="small">Note</label>
              <Input
                placeholder="Optional note"
                value={note}
                onChange={e => setNote(e.target.value)}
              />
            </Col>

          </Row>

          <div className="text-end mt-4">
            <Button disabled={loading} color="success" onClick={submit}>
              Add Stock
            </Button>
          </div>

        </CardBody>
      </Card>
    </>
  );
};

export default InventoryAdd;
